import { useMemo } from "react";
import { AvatarProps } from "@/shared/data-display/avatar";
import { Hidable, Value } from "@/shared/value";
import { AvatarView } from "./avatar-view";
import { HiddenAvatarView } from "../views/hidden-avatar-view";

/**
 * Ссылка на файл аватара приезжает под одним из двух имён — какое выбрал запрос,
 * то и придёт; для показа они равнозначны.
 */
export type AvatarFile = {
  __typename?: "FileDto";
  link?: string | null;
  downloadLink?: string | null;
};

/**
 * Аватар по файлу, закрытому защитой: сам файл, «нет доступа» или пустой аватар.
 * Единственное место, где эта развилка описана, — остальные компоненты вызывают её.
 */
export function HidableAvatarView({
  data,
  ...avatarProps
}: AvatarProps & { data: Hidable<AvatarFile> }) {
  // Обёртки объявлены через useMemo: инлайновая стрелка — это каждый раз новый тип
  // элемента, и React размонтировал бы поддерево заглушки на каждый рендер.
  const [WhenHidden, WhenEmpty] = useMemo(
    () => [
      () => <HiddenAvatarView {...avatarProps} />,
      () => <AvatarView {...avatarProps} />,
    ],
    [avatarProps],
  );

  return (
    <Value data={data} whenHidden={WhenHidden} whenEmpty={WhenEmpty}>
      {(file) => (
        <AvatarView
          {...avatarProps}
          src={file.link ?? file.downloadLink ?? undefined}
        />
      )}
    </Value>
  );
}
